<script setup lang="ts">
import Failed from '@/assets/failed.svg?url';
import Success from '@/assets/success.svg?url';

defineProps({
  completion: {
    type: String,
    required: true,
  },
  message: {
    type: String,
    required: true,
  },
});
</script>
<template>
  <div class="flex grow h-full">
    <div class="grow flex flex-col space-y-4 justify-center items-center">
      <img v-if="completion === 'failed'" :src="Failed" class="h-40" />
      <img v-else :src="Success" class="h-40" />
      <span class="text-center text-xl font-anomaliaBold text-success">
        {{ message }}
      </span>
      <div
        class="text-center text-xl font-simplerRegular text-dark whitespace-pre-line">
        <!-- {{ props.block.settings.success }} -->
        <!-- {{ description }} -->
      </div>
    </div>
  </div>
</template>
